import { render, staticRenderFns } from "./help-icon.vue?vue&type=template&id=2b4da8a2&scoped=true"
import script from "./help-icon.vue?vue&type=script&lang=js"
export * from "./help-icon.vue?vue&type=script&lang=js"
import style0 from "./help-icon.vue?vue&type=style&index=0&id=2b4da8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4da8a2",
  null
  
)

export default component.exports